import type { CalculateIntegrationType } from '../../../types/calculate-integration-type';
import { INTEGRATION } from '../../constants';

export const isCleengIntegrationType: CalculateIntegrationType = (config) => {
  return config.integrations?.cleeng?.id ? INTEGRATION.CLEENG : null;
};

export const isJwpIntegrationType: CalculateIntegrationType = (config) => {
  return config.integrations?.jwp?.clientId ? INTEGRATION.JWP : null;
};

/**
 * VD Private code below
 */
export const isVdOttIntegrationType: CalculateIntegrationType = (config) => {
  return 'vd' in config.integrations ? 'VD' : null;
};

export const isCognitoStripeIntegrationType: CalculateIntegrationType = (config) => {
  return config.custom && 'stripeProductIds' in config.custom ? 'COGNITO_STRIPE' : null;
};
